import axios from "axios";
import { getAuthHeaders } from "../ipd-billing/constants";

export const DELIVERED = "Delivered";

const BASE = process.env.REACT_APP_BACKEND_ROUTE_URL;

const assertStatusUpdateOk = (res) => {
  if (res?.data?.is_valid === false || res?.data?.status === "Failed") {
    throw new Error(res.data?.message || "Request rejected by server");
  }
};

const isIpdPatient = (patient) =>
  patient?.patientType === "IPD" ||
  (patient?.admissionId != null && patient.admissionId !== "");

/**
 * Mark one lab or radiology order Delivered. Both boards write through the
 * same pair of endpoints: IPD by admission + order_no, everything else by
 * lab_test_id (same split as markLabOrderVerified).
 */
export async function setOrderDelivered(patient, order) {
  if (isIpdPatient(patient)) {
    const res = await axios.post(
      `${BASE}update_lab_test_status/`,
      {
        admission_id: String(patient.admissionId),
        order_no: order.orderNo,
        status: DELIVERED,
      },
      { headers: getAuthHeaders(true), skipGlobalLoader: true },
    );
    assertStatusUpdateOk(res);
    return;
  }
  const labTestId = String(
    order?.labTestId || patient?.labTestId || order?.orderNo || "",
  ).trim();
  const res = await axios.post(
    `${BASE}change_patient_lab_test_status/`,
    JSON.stringify({ lab_tests: [{ lab_test_id: labTestId, status: DELIVERED }] }),
    { headers: getAuthHeaders(true), skipGlobalLoader: true },
  );
  assertStatusUpdateOk(res);
}
